import { Header } from "antd/es/layout/layout";
import { Radio, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { fetchBranches } from "../../apis/branch.api";
import BranchDetails from "../../components/branch/branch_details";
import BranchGST from "../../components/branch/branch_gst";
import BranchMemberList from "../../components/branch/branch_members_list";
import TermsAndConditionsList from "../../components/branch/terms_and_conditions";
import PincodeList from "../../components/branch/pincode_list";
import MemberPermissions from "../../components/branch/member_permissions";
import GeneralCoupons from "../../components/branch/general_coupons";
import { usePermissions } from "../../custom_hooks/permission/permission_hook";

const Branch = () => {
  const { hasPermission } = usePermissions();
  const canManagePermissions = hasPermission("admin");
  const canViewCoupons = hasPermission("coupon.read");
  const [branch_id] = useState<number>(1);
  const [branch_data, setBranchData] = useState<any>();
  const [loadingBranch, setLoadingBranch] = useState(true);
  const [tab, setTab] = useState<string>("organisation");

  useEffect(() => {
    let cancelled = false;
    setLoadingBranch(true);
    fetchBranches(branch_id)
      .then((res) => {
        if (!cancelled) setBranchData(res);
      })
      .finally(() => {
        if (!cancelled) setLoadingBranch(false);
      });
    return () => {
      cancelled = true;
    };
  }, [branch_id]);

  return (
    <section className={`lighter-grey-color-bg`}>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          width: "100%",
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-4 align-items-center">
            <div className="primary-color-text th-font-size-20 th-font-weight-700">
              Organisation Details
            </div>
          </div>
        </div>
      </Header>
      <div className="m-4">
        <Radio.Group
          value={tab}
          onChange={(e) => setTab(e.target.value)}
          style={{ marginBottom: 16 }}
        >
          <Radio.Button value="organisation">Organisation</Radio.Button>
          <Radio.Button value="pincodes">Pincodes</Radio.Button>
          {canViewCoupons && <Radio.Button value="coupons">Coupons</Radio.Button>}
          {canManagePermissions && (
            <Radio.Button value="permissions">Permissions</Radio.Button>
          )}
        </Radio.Group>
      </div>

      {tab === "organisation" && (
        <>
          <div className="m-4 p-4 px-5 white-color-bg">
            <div className="row gap-2 my-4">
              <div className="col">
                {loadingBranch && !branch_data ? (
                  <Skeleton active paragraph={{ rows: 6 }} />
                ) : (
                  <BranchDetails branch={branch_data} />
                )}
              </div>
              <div className="col"></div>
            </div>
          </div>
          <div className="m-4 p-4 px-5 white-color-bg">
            <div className="row gap-2 my-4">
              <div className="col">
                <TermsAndConditionsList />
              </div>
            </div>
          </div>
          <div className="m-4 p-4 px-5 white-color-bg">
            <div className="row gap-2 my-4">
              <div className="col">
                <BranchGST />
              </div>
            </div>
          </div>
          <div className="m-4 p-4 px-5 white-color-bg">
            <div className="row gap-2 my-4">
              <div className="col">
                <BranchMemberList branch_id={branch_id} />
              </div>
            </div>
          </div>
        </>
      )}

      {tab === "pincodes" && (
        <div className="m-4 p-4 px-5 white-color-bg">
          <div className="row gap-2 my-4">
            <div className="col">
              <PincodeList />
            </div>
          </div>
        </div>
      )}

      {tab === "coupons" && canViewCoupons && (
        <div className="m-4 p-4 px-5 white-color-bg">
          <div className="row gap-2 my-4">
            <div className="col">
              <GeneralCoupons />
            </div>
          </div>
        </div>
      )}

      {tab === "permissions" && canManagePermissions && (
        <div className="m-4 p-4 px-5 white-color-bg">
          <div className="row gap-2 my-4">
            <div className="col">
              <MemberPermissions />
            </div>
          </div>
        </div>
      )}

    </section>
  );
};

export default Branch;
